import { useController } from '../../hooks/useController'

import { OperationalStorageTips } from './OperationalStorageTips'
import { OperationalWarning } from './OperationalWarning'
import { SimulationWarning } from './SimulationWarning'

export function Body() {
  const {
    data: { percentage, totalOrders, currentOrders, wizardStep, isSimulation },
  } = useController()

  if (isSimulation) {
    return (
      <SimulationWarning
        percentage={percentage}
        totalOrders={totalOrders}
        currentOrders={currentOrders}
      />
    )
  }

  switch (wizardStep) {
    case 'warning':
      return (
        <OperationalWarning
          percentage={percentage}
          totalOrders={totalOrders}
          currentOrders={currentOrders}
        />
      )

    case 'storage-tips':
      return <OperationalStorageTips />

    default:
      throw new Error(`unhandled wizard step: ${wizardStep}`)
  }
}
